module.exports = __webpack_public_path__ + "static/img/hover7.e88e004e.png";